<div class="flex items-center justify-center">
  <ng-container *ngIf="!formAberto">
    <button
      *isAllowed="[ERoleAdminString.Admin, 'role.create']"
      type="button"
      class="w-80 btn btn--secondary mr-5"
      (click)="formAberto = true"
    >
      Cadastrar Nova
    </button>
  </ng-container>

  <button
    *ngIf="formAberto"
    type="button"
    class="btn btn--secondary px-5 h-9 leading-4 text-center ml-auto"
    (click)="formAberto = false"
  >
    X
  </button>
</div>

<div class="font-bold leading-5" *ngIf="formAberto">
  <h1 class="text-lg leading-3">CADASTRAR NOVO PERFIL</h1>
  <small class="text-xs text-chathams-blue">Insira os dados abaixo para cadastrar</small>

  <form [formGroup]="addPerfil" (ngSubmit)="salvarPerfil()" class="flex gap-4 mt-4">
    <input formControlName="description" type="text" class="w-1/5 form-input" placeholder="Nome" />
    <input formControlName="comments" type="text" class="w-3/5 form-input" placeholder="Observação" />
    <div *ngIf="isAdmOlive" class="text-sm text-chathams-blue font-medium leading-4 flex items-center">
      <input
        type="checkbox"
        class="mr-3 form-input form-checkbox on-white check-pink"
        formControlName="adminOlive"
        (change)="convertCheckboxValue()"
      />
      <label>Admin Oliv-e </label>
    </div>
    <button type="submit" class="w-1/5 btn btn--gray">Prosseguir</button>
  </form>
</div>
